<template>
    <div class="row notifications">
        <notifications
            notifications-url="/data/notifications/all"
            view-url="/data/notifications/view-several"
            :dark="true"
        ></notifications>
    </div>
</template>

<script>
import {eventBus} from "@/main";
import Notifications from "@/components/Notification/Notifications";

export default {
    name: "Notifications",
    data () {
        return {

        }
    },
    components: {'notifications': Notifications},
    methods: {
    },
    computed: {
    },
    mounted() {
        eventBus.$emit('changeTop', {title: 'My Notifications', simple: true, topLogo: false});
    }
}
</script>